import { useEffect } from 'react';

export const useOverflowControl = (condition: boolean) => {
  useEffect(() => {
    const app = document.getElementById('root')
      ?.firstElementChild as HTMLElement;

    if (condition && app) {
      app.style.overflowY = 'hidden';
    } else {
      app.style.removeProperty('overflow-y');
    }
  }, [condition]);
};
